<template>
    <v-dialog
        v-model="dialog"
        :persistent="popup.persistent"
        max-width="90%"
        :width="width"
        @keydown.esc="cancel"
    >
        <v-card>
            <v-card-title
                class="headline"
                v-html="popup.title"
                v-if="popup.title"
            />

            <v-card-text
                v-html="popup.content"
                id="popupBody"
                ref="popupBody"
            />
            <v-card-actions class="text-center pb-3">
                <v-row>
                    <v-col v-if="popup.touchable">
                        <v-btn color="red" text @click="visualized">
                            {{ $i18n.t('dialogs.previewPopup.touchBtn') }}
                        </v-btn>
                    </v-col>
                    <v-col>
                        <v-btn color="light-grey darken-2" text @click="close">
                            {{ $i18n.t('dialogs.previewPopup.closeBtn') }}
                        </v-btn>
                    </v-col>
                    <v-col v-if="popup.redirect_to">
                        <v-btn
                            class="col"
                            color="green darken-1"
                            text
                            @click="follow"
                        >
                            {{ $i18n.t('dialogs.previewPopup.followBtn') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from '@/plugins/axios'

export default {
    props: {
        popup: {
            type: Object,
            required: true,
        },

        previewMode: {
            default: false,
        },
    },

    data: () => ({
        dialog: false,
        renderComponent: true,
        width: '500px',
    }),

    watch: {
        dialog(val) {
            if (!val) this.resetIframe()
            if (val) this.setIframeProportion()
        },
    },

    computed: {
        content() {
            return this.$refs.popupBody
        },

        iframe() {
            const content = this.content
            if (content) return content.querySelector('iframe')
            else return null
        },
    },

    methods: {
        open() {
            this.dialog = true
        },

        close() {
            this.dialog = false
        },

        async forceRerender() {
            this.renderComponent = false

            this.$nextTick(() => {
                this.width = this.popup.width
                this.renderComponent = true
            })
        },

        follow() {
            this.dialog = false
            this.$router.push({
                name: this.popup.redirect_to,
            })
        },

        async visualized() {
            if (this.popup.touchable && !this.previewMode) {
                const endpoint = `popups/${this.popup.slug}/touch`
                axios.post(endpoint)
            }

            this.dialog = false
        },

        async resetIframe() {
            const iframe = this.iframe
            if (iframe) iframe.src = iframe.src
        },

        async setIframeProportion(attempt) {
            const maxAttempts = 100
            attempt = attempt == undefined ? 0 : attempt

            const resize = function() {
                attempt += 1
                if (!this.dialog) return
                const content = this.$refs.popupBody

                if (!content && attempt <= maxAttempts) {
                    this.setIframeProportion(attempt++)
                    return
                }

                const iframe = content.querySelector('iframe')

                if (!iframe) {
                    return
                }

                const height = (9 * iframe.clientWidth) / 16
                iframe.height = height + 'px'
            }.bind(this)

            setTimeout(resize, 100)
        },
    },

    created() {
        if (this.popup.width) this.width = this.popup.width
        if (!this.previewMode) this.dialog = true
        addEventListener('resize', () => this.setIframeProportion())
    },
}
</script>
